export const locales = [
    'da-DK',
    'de-AT',
    'de-CH',
    'de-DE',
    'en-AU',
    'en-CA',
    'en-GB',
    'en-IE',
    'en-IN',
    'en-NZ',
    'en-SG',
    'en-US',
    'es-ES',
    'es-US',
    'fi-FI',
    'fr-BE',
    'fr-CA',
    'fr-CH',
    'fr-FR',
    'it-CH',
    'it-IT',
    'nb-NO',
    'nl-BE',
    'nl-NL',
    'pt-PT',
    'sv-SE',
] as const;
export type SupportedLocale = (typeof locales)[number];

export function lowercaseLocaleToIso(locale: string): SupportedLocale {
    const localeParts = locale.split('-');
    if (localeParts.length > 1) {
        return `${localeParts[0]}-${localeParts[1].toUpperCase()}` as SupportedLocale;
    }
    return locale as SupportedLocale;
}
